import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { Card, Image } from 'semantic-ui-react'
import muiThemeable from 'material-ui/styles/muiThemeable'

const IconCard = compose(
  muiThemeable()
)(
  ({
    icon,
    caption,
    onClick,
    isActive,
    muiTheme: {
      palette: {
        accent1Color,
      }
    }
  }) => {
    return (
      <Card
        onClick={onClick}
        style={{
          ...isActive && {
            boxShadow: `0 1px 3px 0 ${accent1Color}, 0 0 0 1px ${accent1Color}`
          }
        }}
      >
        <Image
          src={icon}
          style={{
            background: '#ffffff',
          }}
        />
        <Card.Content
          style={{
            padding: 5,
            borderTop: 0,
          }}
        >
          <Card.Description
            style={{
              ...isActive && { color: accent1Color },
              marginTop: 0,
            }}
          >
            {caption}
          </Card.Description>
        </Card.Content>
      </Card>
    )
  }
)

IconCard.propTypes = {
  icon: PropTypes.string.isRequired,
  caption: PropTypes.string,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
}
IconCard.defaultProps = {
  caption: '',
  isActive: false,
}

export default IconCard



// WEBPACK FOOTER //
// ./src/components/Card/IconCard.js